export default __webpack_public_path__ + "d346634a40da55b3cb065fea8664623b.png";